import UNIQUE from '@/common/unique'
import columnDetail from '../columnDetail'
export default {
  id: 'image1',
  name: 'image1',
  type: 'standard',
  moduleName: 'editor_module_image1',
  dataSet: {
    mods: 'flexible',
    column: [
      {
        columnId: UNIQUE.mid(),
        flex: 1,
        type: 'image',
        value: null,
        detail: {
          options: ['link', 'border', 'background', 'upload', 'radius'],
          link: columnDetail.link,
          border: columnDetail.border,
          background: columnDetail.background,
          upload: columnDetail.upload,
          radius: columnDetail.radius
        }
      }
    ]
  },
  setting: {
    layout: {
      options: [
        'link',
        'fullsize',
        'columns',
        'background',
        'border',
        'text',
        'padding'
      ]
    },
    action: null,
    detail: {}
  }
}
